import React from 'react';
import LocationTemplate from './LocationTemplate';

const DurhamPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Durham"
      stateName="North Carolina"
      countyName="Durham"
      zipCodes={["27701", "27702", "27703", "27704", "27705", "27706", "27707", "27708", "27709", "27710", "27711", "27712", "27713", "27715", "27717"]}
      latitude={35.9940}
      longitude={-78.8986}
      population={278993}
      historicalFact="Known as the 'City of Medicine' and home to Duke University; major center for research and technology."
      nearbyTowns={[
        "Raleigh, NC",
        "Chapel Hill, NC",
        "Cary, NC",
        "Wake Forest, NC",
        "Burlington, NC",
        "Hillsborough, NC",
        "Oxford, NC",
        "Pittsboro, NC"
      ]}
    />
  );
};

export default DurhamPage;